module.exports = {"master":{"setings":"Settings"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/master.json
// module id = 551
// module chunks = 35